import React from 'react';
import type { PriceTargetsWidgetConfig } from './types';
import { definition } from './index';

interface Props {
  config: Partial<PriceTargetsWidgetConfig>;
  onChange: (config: PriceTargetsWidgetConfig) => void;
}

const PriceTargetsWidgetBuilder: React.FC<Props> = () => (
  <div className="space-y-4">
    <div className="bg-warning-50 border border-warning-200 rounded-lg p-4 text-sm text-warning-800">
      <strong>{definition.meta.label}</strong>
      <p className="mt-1">{definition.meta.description}</p>
    </div>
    <div className="border rounded-lg p-4 bg-primary-50 border-primary-200">
      <h4 className="font-medium text-primary-800 mb-2">How it works</h4>
      <ul className="text-sm text-primary-700 space-y-1 ml-5 list-disc">
        <li>Consensus 12-month average price target + analyst count</li>
        <li>Implied upside/downside vs the current price</li>
        <li>Buy / Hold / Sell rating distribution</li>
        <li>Sourced from the FMP analyst feed</li>
      </ul>
    </div>
  </div>
);

export default PriceTargetsWidgetBuilder;
